import { render, staticRenderFns } from "./ResetPwdConfirm.vue?vue&type=template&id=e7633a36&scoped=true&"
import script from "./ResetPwdConfirm.vue?vue&type=script&lang=ts&"
export * from "./ResetPwdConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPwdConfirm.vue?vue&type=style&index=0&id=e7633a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7633a36",
  null
  
)

export default component.exports